export const SEARCH_EXPERTS_START = "SEARCH_EXPERTS_START";
export const SEARCH_EXPERTS_SUCCESS = "SEARCH_EXPERTS_SUCCESS";
export const SEARCH_EXPERTS_FAILURE = "SEARCH_EXPERTS_FAILURE";

export const UPDATE_EXPERT_EMAIL_START = "UPDATE_EXPERT_EMAIL_START";
export const UPDATE_EXPERT_EMAIL_SUCCESS = "UPDATE_EXPERT_EMAIL_SUCCESS";
export const UPDATE_EXPERT_EMAIL_FAILURE = "UPDATE_EXPERT_EMAIL_FAILURE";